import { buttonVariants } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import { faArrowLeft, faPlusLarge } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useTerminKalenderList } from '@/domain/termine/hooks/useTerminKalenderList';
import {
  useKalenderTableColumns,
  KalenderTable,
} from '@/domain/termine/features/TerminKalender/Desktop/Table';

export function KalenderDesktopContent() {
  const { t } = useTranslation();
  const { kalender } = useTerminKalenderList();
  const filteredData = kalender.filter((row) => row.kalenderSchluessel !== -1);
  const columns = useKalenderTableColumns();

  return (
    <>
      <div className="flex gap-2 items-start justify-between w-full">
        <div className="flex items-center gap-2">
          <Link
            to="/termine/uebersicht"
            aria-label={t('domain.termine.title')}
            title={t('domain.termine.title')}
            className={cn(buttonVariants({ variant: 'ghost', size: 'icon' }))}>
            <FontAwesomeIcon icon={faArrowLeft} />
          </Link>
          <span className="font-semibold text-sm">
            {t('domain.termine.title')}
          </span>
        </div>
      </div>

      <div className="w-full">
        <div className="flex items-center justify-between mb-5">
          <span className="text-xl font-bold">
            {t('domain.termine.createTitle')}
          </span>
          <Link
            to=""
            className={cn(
              buttonVariants({ variant: 'default', size: 'icon' }),
            )}>
            <FontAwesomeIcon icon={faPlusLarge} className="font-bold" />
          </Link>
        </div>
        <div className="mt-5">
          <KalenderTable columns={columns} data={filteredData} />
        </div>
      </div>
    </>
  );
}
